import { useContext } from 'react';
// eslint-disable-next-line max-len
import { EndorsementServiceFeaturesGetAllCertificatesGetAllCertificatesDto as CertificatesDto } from '@sdir/httpclient/lib/clients/aps/endorsement';
import { Loadable } from '../../types';
import { CertificatesContext } from '../contexts/CertificatesContext';

export const useCertificates = (): Loadable<CertificatesDto[]> => {
  const context = useContext(CertificatesContext);

  return context;
};
